export default __webpack_public_path__ + "static/media/about.c6ec9215.jpg";